import { Provider } from "./provider/Provider";

const ModuleService = {
  modulesList: () => {
    return Provider({
      methodName: "Api/Module/ModulesList",
    });
  },
  getModulesList: () => {
    return Provider({
      methodName: "Api/Module/GetModulesList",
    });
  },
  getRoutersList: () => {
    return Provider({
      methodName: "Api/Module/GetRoutersList",
    });
  },
};

export default ModuleService;
